import { render } from "./PricesMobile.vue?vue&type=template&id=961936a0"
import script from "./PricesMobile.vue?vue&type=script&lang=js"
export * from "./PricesMobile.vue?vue&type=script&lang=js"

import "./PricesMobile.vue?vue&type=style&index=0&id=961936a0&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__